import styles from "./Divider.module.scss";

const Divider = ({ className }) => {
	return <div className={`${styles.dividerComponent} ${className}`}></div>;
};

export default Divider;
